import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { arcs } from "@/mocks/arcs";

export default function Arcs() {
  const [openId, setOpenId] = useState(arcs[0].id);

  return (
    <section id="arcs" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="篇章解析"
            title="按顺序理清剧情脉络"
            desc="作品的时间线跨越日常、战斗与未来，下面按发生的先后顺序，把每一段的核心冲突与看点整理出来。点击任意篇章展开细节。"
          />
        </Reveal>

        <div className="mt-10 space-y-4">
          {arcs.map((arc, index) => {
            const isOpen = openId === arc.id;
            return (
              <Reveal key={arc.id} delay={Math.min(index * 60, 240)}>
                <article
                  className={`overflow-hidden rounded-lg border bg-background-100 transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? "" : arc.id)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center gap-4 px-4 py-5 text-left md:px-6"
                  >
                    <span
                      className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {arc.no}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex flex-wrap items-center gap-x-3 gap-y-1">
                        <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">{arc.title}</span>
                        <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800">{arc.tag}</span>
                      </span>
                      <span className="mt-1.5 block flex-wrap gap-2 text-xs text-foreground-500">
                        {arc.keywords.join(" · ")}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 text-xl text-foreground-500 transition-transform ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    />
                  </button>

                  {isOpen ? (
                    <div className="border-t border-background-200 px-4 pb-6 pt-5 md:px-6">
                      <p className="text-sm leading-7 text-foreground-700 md:text-base md:leading-8">{arc.summary}</p>
                      <h3 className="mt-5 flex items-center gap-2 text-sm font-bold text-foreground-950">
                        <i className="ri-bookmark-3-line text-accent-600" />
                        不可错过的看点
                      </h3>
                      <ul className="mt-3 grid gap-2.5 sm:grid-cols-1">
                        {arc.points.map((point) => (
                          <li key={point} className="flex items-start gap-2.5 text-sm leading-6 text-foreground-700">
                            <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-primary-500" />
                            <span>{point}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null}
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}